// extracted by mini-css-extract-plugin
module.exports = {"recaptchaContainer":"B4OFbr6ApoEXauLcs3SwS","invalidRecaptcha":"FMwBHB7NM3a9HkivAEi27","showOnXs":"_1c9g29S2qz4PW1zWi9ZG94","hideOnXs":"_3AOnUkim7QrBdturGPdbGu"};